export default __webpack_public_path__ + "static/media/montserrat.97471a28.woff";